import type { Task } from "~skillBuilder/utils/types";

export const POverview = {
  name: "Overview",
  uniqueName: "p-overview",
  icon: "Overview",
  durationTimeText: "1 min",
  isIntro: true,
  steps: [
    // Step 1
    {
      nextButtonText: "Start Lesson",
      questions: [
        // Question 1.1
        {
          attribute: "professionalism.overview/overview",
          label: "",
          // description: "",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `Maintaining professionalism in a school setting sets the stage for a smooth, productive day—for both you and your students. As a substitute teacher, stepping into a new classroom can feel like navigating uncharted territory, but a professional approach helps you make a good impression, build trust, and foster a positive learning environment. In this lesson, we relay tips and tricks from our school partners to help you establish yourself as a trusted, star sub.`,
          },
        },
      ],
    },
  ],
} as const satisfies Task;
